"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventStatusDisplay = exports.EventStatusLabels = exports.LodgingArrangments = exports.Meals = exports.RequiredForms = exports.Activities = exports.CUniforms = exports.SMUniforms = void 0;
const types_1 = require("../typings/types");
exports.SMUniforms = [
    'Dress Blue A',
    'Dress Blue B',
    'Airman Battle Uniform (ABU) or Operational Camouflage Pattern (OCP)',
    'PT Gear',
    'Polo Shirts',
    'Blue Utilities',
    'Civilian Attire',
    'Flight Suit',
    'Not Applicable',
];
exports.CUniforms = [
    'Dress Blue A',
    'Dress Blue B',
    'Airman Battle Uniform (ABU) or Operational Camouflage Pattern (OCP)',
    'PT Gear',
    'Civilian Attire',
    'Flight Suit',
    'Not Applicable',
];
exports.Activities = [
    'Squadron Meeting',
    'Classroom/Tour/Light',
    'Backcountry',
    'Flying',
    'Physically Rigorous',
    'Recurring Meeting',
];
exports.RequiredForms = [
    'CAP Identification Card',
    'CAPF 31 Application For CAP Encampment Or Special Activity',
    'CAPF 60-80 Civil Air Patrol Cadet Activity Permission Slip',
    'CAPF 101 Specialty Qualification Card',
    'CAPF 160 CAP Member Health History Form',
    'CAPF 161 Emergency Information',
    'CAPF 163 Permission For Provision Of Minor Cadet Over-The-Counter Medication',
];
exports.Meals = ['No meals provided', 'Meals provided', 'Bring own food', 'Bring money'];
exports.LodgingArrangments = [
    'Hotel or individual room',
    'Open bay building',
    'Large tent',
    'Individual tent',
];
exports.EventStatusLabels = [
    'Draft',
    'Tentative',
    'Confirmed',
    'Complete',
    'Cancelled',
    'Information Only',
];
exports.EventStatusDisplay = {
    [types_1.EventStatus.DRAFT]: 'Draft',
    [types_1.EventStatus.TENTATIVE]: 'Tentative',
    [types_1.EventStatus.CONFIRMED]: 'Confirmed',
    [types_1.EventStatus.COMPLETE]: 'Complete',
    [types_1.EventStatus.CANCELLED]: 'Cancelled',
    [types_1.EventStatus.INFORMATIONONLY]: 'Information Only',
};
//# sourceMappingURL=labels.js.map